import React from "react";
import { isCssAnimationSupported, isHighContrast } from "../ProgressIndicator/browserHelper";
import { marchingAntsGif } from "../ProgressIndicator/imageHelpers/accessibleImages";
import { AccessibleImage } from "../ProgressIndicator/AccessibleImage/AccessibleImage";
import { useProgressIndicatorStyles } from "../ProgressIndicator/progressIndicator.styles";
import { IAttributes, IUCISModel } from "../../Interfaces/interface";

/**
 * ProgressIndicator component
 * @returns PLACEHOLDER - NEEDS TO BE UPDATED
 */

const ProgressIndicator: React.FC = () => {
    const styles = useProgressIndicatorStyles();
    const useCssAnimation = isCssAnimationSupported() && !isHighContrast();
    const ucisData: IUCISModel = window.ucis;
    const ucisModelTexts: IAttributes = ucisData?.ModelSchema?.modelTexts[0].attributes;

    return (
        <div
            className={styles.progress}
            role="progressbar"
            aria-label={ucisModelTexts["general-pleaseWait"]}
        >
            {useCssAnimation ? (
                <>
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                </>
            ) : (
                <AccessibleImage accessibleImages={marchingAntsGif} role="presentation" />
            )}
        </div>
    );
};

export default ProgressIndicator;
